import { render, staticRenderFns } from "./Deduct.vue?vue&type=template&id=6da56f0c&scoped=true"
import script from "./Deduct.vue?vue&type=script&lang=js"
export * from "./Deduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da56f0c",
  null
  
)

export default component.exports